import { render, staticRenderFns } from "./TimedAutomation2.vue?vue&type=template&id=b36ffa76&scoped=true"
import script from "./TimedAutomation2.vue?vue&type=script&lang=js"
export * from "./TimedAutomation2.vue?vue&type=script&lang=js"
import style0 from "./TimedAutomation2.vue?vue&type=style&index=0&id=b36ffa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36ffa76",
  null
  
)

export default component.exports